import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const OesangWeb = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() + 1000 * 60 * 60 * 9 - 1000 * 60 * 60 * 24 * 7).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchGubun: '01',
        searchDateCls: '01',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['구분', '기관명', '환자의무기록번호', '내원일자', '성명', '나이', '표준 전송일시', '외상 전송일시', '외상전송 상태값', '퇴실일시', '퇴원일시']; //component화 
    const dataColumn = ['STAT', 'EMOGDESC', 'PTMIMASK', 'PTMIINDTM', 'PTMINAME', 'PTMIBRTD', 'PTMIWKDTM', 'TRMSWKDTM', 'TRMSSTAT', 'PTMIOTDTM', 'PTMIDCDTM'];
    const apiCall = '/trmsapi/oesangweb/bdtrms_init_b.do';
    const apiCntCall = '/trmsapi/oesangweb/bdtrms_init_b_cnt.do';
    const excelFileName = '입력대상조회';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="26%" />
                        <col width="10%" />
                        <col width="17%" />
                        <col width="10%" />
                        <col width="17%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="01">내원일자</option>
                                    <option value="02">전송일자</option>
                                </select>
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="01">전체</option>
                                    <option value="02">입력대상</option>
                                    <option value="03">입력중</option>
                                    <option value="04">외상삭제</option>
                                    <option value="05">외상환자제외</option>
                                    <option value="06">연동후제외</option>
                                    <option value="07">입력완료</option>
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <div>
                <p>* 입력 대상: 외상 등록 대상 조건을 충족하여 입력되어야 하는 건</p>
                <p>* 입력 중: 입력 대상 중 입력완료가 되지 않은 건</p>
                <p>* 외상 삭제: 외상등록체계에서 삭제한 건 (D flag 전송하여 퇴원 정보만 삭제된 건 포함)</p>
                <p>* 외상환자제외(P): 외상 등록 대상 조건을 충족하였으나 기관에서 등록 대상이 아니라고 판단된 건</p>
                <p>* 연동후 제외: 외상 등록 대상 조건을 충족하여 연동되었으나, 표준등록체계 정보가 변경되어 외상 등록 대상에서 제외된 건</p>
                <p className='ml-2'> - 연동후 제외(Y): 표준등록체계 재전송 시 외상 등록 대상 조건 미충족</p>
                <p className='ml-2'> - 연동후 제외(D): 표준등록체계에서 삭제한 건 (D flag 전송하여 퇴원 정보만 삭제된 건 포함)</p>
                <p className='ml-2'> - 연동후 제외(E): 표준등록체계에서 오류로 확인됨 (V2.1까지만 사용)</p>
                <p>* 입력완료: 입력 완료된 건</p>
                <p>* '외상환자 제외' 및 '외상 삭제'인 경우라도 '연동 후 제외'인 건은 '연동 후 제외'로 조회</p>
            </div>
        </Main>
    )
}

export default OesangWeb;